import React, { useState, useEffect } from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { axisClasses } from "@mui/x-charts/ChartsAxis";
import ShipmentInquiriesService from "../../services/ShipmentInquiriesService";
import { snackbarActions } from "../../Store/snackbar";
import { useDispatch } from "react-redux";

function valueFormatter(value) {
  return `${value}`;
}

const chartSetting = {
  yAxis: [
    {
      label: "No of Inquiries",
    },
  ],
  width: 800,
  height: 400,
  sx: {
    [`.${axisClasses.left} .${axisClasses.label}`]: {
      transform: "translate(-10px, 0)",
    },
  },
};

const InquiriesSummary = ({ value }) => {
  const [dataset, setDataset] = useState([]);
  const dispatch = useDispatch();

  const generateChartData = (tableData) => {
    const monthlyData = {};
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    months.forEach((month) => {
      monthlyData[month] = {
        pending: 0,
        approved: 0,
        complete: 0,
        biorep_rejected: 0,
        month: month,
      };
    });
    tableData.forEach((record) => {
      const date = new Date(record.created_at);
      const month = date.toLocaleString("en-US", { month: "short" });
      switch (record.status) {
        case "pending":
          monthlyData[month].pending++;
          break;
        case "biorep_rejected":
          monthlyData[month].biorep_rejected++;
          break;
        case "approved":
          monthlyData[month].approved++;
          break;
        case "complete":
          monthlyData[month].complete++;
          break;
      }
    });
    return months.map((month) => monthlyData[month]);
  };

  useEffect(() => {
    ShipmentInquiriesService.getInquiryList()
      .then((resp) => {
        const chartData = generateChartData(resp.data);
        setDataset(chartData);
      })
      .catch((err) => {
        dispatch(
          snackbarActions.showNotification({
            snackbarOpen: true,
            snackbarType: "error",
            snackbarMessage: err.message,
          })
        );
      });
  }, []);

  return (
    <>
      {value === "four" && (
        <BarChart
          dataset={dataset}
          xAxis={[{ scaleType: "band", dataKey: "month" }]}
          series={[
            {
              dataKey: "pending",
              label: "Pendging",
              valueFormatter,
            },
            {
              dataKey: "biorep_rejected",
              label: "Biorep Rejected",
              valueFormatter,
            },
            { dataKey: "approved", label: "approved", valueFormatter },
            { dataKey: "complete", label: "Complete", valueFormatter },
          ]}
          {...chartSetting}
        />
      )}
    </>
  );
};

export default InquiriesSummary;
